<ng-container [formGroup]="formGroup">
  <div class="section">
    <div class="section-header">
      <pdq-heading element="h5">Offer</pdq-heading>
      <pdq-button
        class="eye-preview-button"
        variant="empty"
        [icon]="isOfferPreviewActive ? 'preview_eye' : 'preview_eye_crossed'"
        [iconColor]="isOfferPreviewActive ? 'var(--primary-default)' : 'var(--on-surface-light)'"
        (click)="previewToggle.emit()">
      </pdq-button>
    </div>

    <div class="controls-wrapper">
      @if (giftMessageEnabled) {
        <pdq-tabs-group leftMargin="small" (onChange)="onPopupTabChange($event)">
          <pdq-tab value="giftPopup" label="Information Provided" [active]="popupActiveTab === 'giftPopup'"></pdq-tab>
          <pdq-tab
            value="missingInformationPopup"
            label="Information Not Provided"
            [active]="popupActiveTab === 'missingInformationPopup'"></pdq-tab>
        </pdq-tabs-group>
      }

      @if (isInformationProvided) {
        @switch (formGroup.get('settings.offerType').value) {
          @case (OfferType.SELLING_PLAN_PRODUCT) {
            <gift-unlock-offer-selling-plan
              [formGroup]="formGroup"
              [couponTypeOptions]="couponTypeOptions"
              [shopCurrencySymbol]="shopCurrencySymbol"
              [isAutoApplyEnabled]="isAutoApplyEnabled">
            </gift-unlock-offer-selling-plan>
          }
          @case (OfferType.COUPON) {
            <gift-unlock-offer-coupon
              [formGroup]="formGroup"
              [couponTypeOptions]="couponTypeOptions"
              [shopCurrencySymbol]="shopCurrencySymbol"
              [updateRequired]="updateRequired"
              [updateAppUrl]="updateAppUrl">
            </gift-unlock-offer-coupon>
          }
          @case (OfferType.PRODUCT) {
            <gift-unlock-offer-product
              [formGroup]="formGroup"
              [couponTypeOptions]="couponTypeOptions"
              [shopCurrencySymbol]="shopCurrencySymbol"
              [giftMessageEnabled]="giftMessageEnabled"
              [isAutoApplyEnabled]="isAutoApplyEnabled">
            </gift-unlock-offer-product>
          }
        }
      } @else {
        <pdq-input [formControl]="formGroup.get('missingInformationPopup.title')" label="Pop Up Display Title">
        </pdq-input>
        <pdq-input [formControl]="formGroup.get('missingInformationPopup.text')" label="Pop Up Display Subtitle">
        </pdq-input>
        <pdq-input
          [formControl]="formGroup.get('missingInformationPopup.dismissButtonText')"
          label="Dismiss Button Text">
        </pdq-input>
      }
    </div>
  </div>
</ng-container>
